import { Box, Portal, useDisclosure } from '@chakra-ui/react';
import { getAuthToken } from 'api/helpers';
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { MAIN_URL, SIGN_OUT, allRoutes, sidebarRoutes } from 'routes';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchMe, selectMe, selectMeIsLoading } from 'store/slices/user';

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
    const hasToken = getAuthToken();

    const dispatch = useAppDispatch();
    const me = useAppSelector(selectMe);
    const meIsLoading = useAppSelector(selectMeIsLoading);

    console.log({ me, meIsLoading });

    const location = useLocation();
    console.log(location);

    useEffect(() => {
        if (hasToken) {
            dispatch(fetchMe());
        }
        // dispatch(fetchUserById('id123'));
        // dispatch(fetchUpdatePassword({ test: '123' }));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const { ...rest } = props;
    // states and functions
    const [fixed] = useState(false);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    // functions for changing the states from components
    const getActiveRoute = (routes: RoutesType[]): string => {
        for (let i = 0; i < routes.length; i++) {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                return routes[i].name;
            }
        }
    };
    const getActiveNavbar = (routes: RoutesType[]): boolean => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                return routes[i].secondary;
            }
        }
        return activeNavbar;
    };
    const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                return routes[i].name;
            }
        }
        return activeNavbar;
    };
    const getRoutes = (routes: RoutesType[]): any => {
        return routes.map((route: RoutesType, key: any) => {
            if (route.layout === '/admin') {
                return <Route path={`${route.path}`} element={route.component} key={key} />;
            } else {
                return null;
            }
        });
    };
    const { onOpen } = useDisclosure();

    return hasToken ? (
        <Box>
            {me && (
                <SidebarContext.Provider
                    value={{
                        toggleSidebar,
                        setToggleSidebar,
                    }}
                >
                    <Sidebar routes={sidebarRoutes} display="none" {...rest} />
                    <Box
                        bgColor="gray.100"
                        float="right"
                        minHeight="100vh"
                        height="100%"
                        overflow="auto"
                        position="relative"
                        maxHeight="100%"
                        w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                        maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                        transitionDuration=".2s, .2s, .35s"
                        transitionProperty="top, bottom, width"
                        transitionTimingFunction="linear, linear, ease"
                    >
                        <Portal>
                            <Box>
                                <Navbar
                                    onOpen={onOpen}
                                    logoText={'Horizon UI Dashboard PRO'}
                                    brandText={getActiveRoute(allRoutes)}
                                    secondary={getActiveNavbar(allRoutes)}
                                    message={getActiveNavbarText(allRoutes)}
                                    fixed={fixed}
                                    {...rest}
                                />
                            </Box>
                        </Portal>

                        <Box mx="auto" minH="100vh" padding="24px" paddingTop="120px">
                            <Routes>
                                {getRoutes(allRoutes)}
                                <Route path="/" element={<Navigate to={MAIN_URL} replace />} />
                            </Routes>
                        </Box>
                    </Box>
                </SidebarContext.Provider>
            )}
        </Box>
    ) : (
        <Navigate to={SIGN_OUT.fullPath} />
    );
}
